import { render } from "./FileAudio.vue?vue&type=template&id=b59c09fe&scoped=true&ts=true"
import script from "./FileAudio.vue?vue&type=script&lang=ts"
export * from "./FileAudio.vue?vue&type=script&lang=ts"

import "./FileAudio.vue?vue&type=style&index=0&id=b59c09fe&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b59c09fe"]])

export default __exports__